import React, { useState } from "react";
import "./SelectDropDownComp.css";

const SelectDropDownComp = ({
  allOptions = [],
  selectedValues = [],                 // now expects [{id, label}, ...]
  setSelectedValues = () => {},
  onApply = () => {},
  loading = false,
  setIsDropdownOpen = () => {},
  multiSelect = true,
  valueKey = "id",
  labelKey = "label",
  showSearch = true,
  placeholder = "Search...",
  disableFooter = true,
  submitTxt="Apply",
  disabledSubmit=false
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredList = Array.isArray(allOptions)
    ? allOptions.filter((item) =>
        item[labelKey]?.toLowerCase().includes(searchQuery?.toLowerCase())
      )
    : [];

  // 👉 Check by valueKey if item is already selected
  const isSelected = (val) => {
    return multiSelect
      ? selectedValues?.some((obj) => obj[valueKey] === val)
      : selectedValues?.[valueKey] === val;
  };

  // 👉 Toggle full object in selection list
  const toggleSelect = (valObj) => {
    if (multiSelect) {
      setSelectedValues((prev = []) => {
        const exists = prev.some((obj) => obj[valueKey] === valObj[valueKey]);
        return exists
          ? prev.filter((obj) => obj[valueKey] !== valObj[valueKey])
          : [...prev, valObj];
      });
    } else {
      setSelectedValues((prev) =>
        prev?.[valueKey] === valObj[valueKey] ? null : valObj
      );
    }
  };
  // console.log("selectedValues",selectedValues)

  return (
    <div className="select-dropdown-comp">
      {showSearch && (
        <input
          type="text"
          placeholder={placeholder}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="select-dropdown-search-input"
        />
      )}

      {!loading && (
        <ul className="select-dropdown-option-list">
          {filteredList.map((item) => (
            <li key={item[valueKey]} className="select-dropdown-option-item">
              <label>
                <input
                  type="checkbox"
                  checked={isSelected(item[valueKey])}
                  onChange={() => toggleSelect(item)}
                  disabled={!multiSelect && isSelected(item[valueKey])}
                />
                {item[labelKey]}
              </label>
            </li>
          ))}
        </ul>
      )}

      {!disableFooter && (
        <div className="button-row">
          <button
            className="cancel-btn"
            onClick={() => {
              setIsDropdownOpen(false);
              setSelectedValues(multiSelect ? [] : null);
            }}
          >
            Cancel
          </button>
          {loading ? (
            <div className="btn-spinner"></div>
          ) : (
            <button
            disabled={disabledSubmit}
              className="apply-btn"
              onClick={() =>{
                onApply(selectedValues)}}
            >
              {submitTxt}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectDropDownComp;
